<!-- Account Information-->
<div class="container content-box">
    <h1 class="text-center">My Account</h1>

    <!-- Update Form -->
    <form name="form" (submit)="f.form.valid && onUpdate(f)" #f="ngForm" novalidate>

        <!-- User Info Fields-->
        <div class="col-md-12">

            <!-- Email -->
            <div class="row mt-2">
                <div class="col-md-12 mt-2"><label>Email:</label><input type="text" class="form-control" [formControl]="email" readonly [placeholder]="user.email || 'email'" [ngClass]="{disabledDiv: !isActiveDiv}"></div>
            </div>

            <!-- Input Row -->
            <div class="row mt-2">

                <!-- First Name -->
                <div class="col-md-6">
                    <label class="required-field">First Name</label>
                    <input type="text" class="form-control mb-2" [formControl]="firstName" [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }">

                    <!-- Invalid -->
                    <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
                        <div class="mb-2" *ngIf="firstName.errors!.required">First name is required</div>
                    </div>
                </div>

                <!-- Last Name -->
                <div class="col-md-6">
                    <label class="required-field">Last Name</label>
                    <input type="text" class="form-control mb-2" [formControl]="lastName" [ngClass]="{ 'is-invalid': f.submitted && lastName.invalid }">

                    <!-- Invalid -->
                    <div *ngIf="f.submitted && lastName.invalid" class="invalid-feedback">
                        <div class="mb-2" *ngIf="lastName.errors!.required">Last name is required</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Buttons -->
        <div class="mt-5 text-center">
            <!-- Save Profile -->
            <button type="submit" class="btn waves-dark">Update Info</button>
        </div>
    </form>
</div>
